import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlMermaPartSecured,
  urlMyMermaPartSecured,
  urlExportMermaPartSecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_WORKING_PART,
  GET_WORKING_PART,
  UPDATE_WORKING_PART,
  DELETE_WORKING_PART,
  FILTER_WORKING_PART,
} from "../../constants/index";
import moment from "moment-timezone";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.dateInit) {
      const dateInit = moment(filters.dateInit);
      filter += "&dateInit=" + dateInit.valueOf();
    }
    if (filters.dateEnd) {
      const dateEnd = moment(filters.dateEnd);
      filter += "&dateEnd=" + dateEnd.valueOf();
    }
    if (filters.viveroUuid !== undefined)
      filter += "&viveroUuid=" + filters.viveroUuid;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Get MermaPart by uuid.
 */
export const getMermaPartByUuid = createAction(GET_WORKING_PART, (param) =>
  apiGet(urlMermaPartSecured, param, true)()
);

/**
 * Filter list MermaPart.
 */
export const filterMermaPart = createAction(
  "FILTER_MERMA_PART",
  (filter, param) =>
    apiGet(urlMermaPartSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create MermaPart.
 */
export const createMermaPart = createAction("CREATE_MERMA_PART", (obj) =>
  apiPost(urlMermaPartSecured, obj, undefined, true)()
);

/**
 * Update MermaPart.
 */
export const modifyMermaPart = createAction(UPDATE_WORKING_PART, (obj, param) =>
  apiPut(urlMermaPartSecured, obj, param, true)()
);

/**
 * Delete MermaPart by uuid.
 */
export const removeMermaPart = createAction(DELETE_WORKING_PART, (param) =>
  apiDelete(urlMermaPartSecured, param, true)()
);

/**
 * Filter list orders.
 */
export const listMermaPartToExport = createAction(
  "EXPORT_FILTER_ITEMS",
  (filter, param) =>
    apiGet(
      urlExportMermaPartSecured + generateFilterQuery(filter),
      param,
      true
    )()
);
